<template>
  <qx-card title="列表">
    <DiffFeeDialog ref="diffFeeDialog" @sub="getData" />
    <LogRightDialog ref="logRightDialog" busiCode="230004" />
    <CheckNameDialog ref="checkNameDialog" @sub="getData" />
    <section slot="titleLeft">
      【已核销总金额：
      <span class="primary">{{ totalData.receiveToatlFee / 100 }}</span>
      】 【未核销总金额：
      <span class="primary">{{ totalData.uncollectedTotalFee / 100 }}</span>
      】
    </section>
    <section slot="titleRight">
      <qx-permpisions permpisions="1004010101">
        <el-button type="primary" plain @click="showCheckNameDialog"
          >修改对账名称</el-button
        >
      </qx-permpisions>
      <!-- <qx-permpisions permpisions="">
        <el-button type="primary" plain>快速创建账单</el-button>
      </qx-permpisions>-->
      <qx-permpisions permpisions="2000102">
        <el-button type="primary" plain @click="customerOrderCreateBill"
          >创建账单</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions="2000103">
        <ImportBtn
          :customPost="true"
          :isDownloadLocalTemplate="true"
          @sub="onImportBtnSub"
          title="应收账单导入"
          fileUrl="/file/应收账单导入模板.xlsx"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="2000104">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="receviceManageBO.ajax?cmd=queryReceviceManageOrder"
          :params="fullSearchData"
          bizName="应收结算订单数据导出"
          bizCode="exp100060"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <!-- 订单号 -->
                <section
                  v-if="scope.column.property === 'orderId'"
                  class="primary cur"
                  @click="toOrderDetail(scope.row)"
                >
                  {{ scope.row[scope.column.property] }}
                </section>
                <!-- 账单号码 -->
                <!-- <section
                v-else-if="scope.column.property === 'billNumber'"
                class="primary cur"
                @click="toBillDetail(scope.row)"
              >
                {{ scope.row[scope.column.property] }}
              </section>-->
                <!-- 运输线路 -->
                <section
                  v-else-if="scope.column.property === 'sourceRegionName'"
                  @click="toOilRecharge(scope.row.busiCode)"
                >
                  {{ scope.row.sourceRegionName }}-{{ scope.row.desRegionName }}
                </section>
                <!-- 对账调整 -->
                <section
                  v-else-if="scope.column.property === 'diffFeeDouble'">
                  <template v-if="checkPermpisions('2000105')">
                    <span  class="primary cur" @click="showDiffFeeDialog(scope.row)">
                      {{ scope.row[scope.column.property] }}
                    </span>
                  </template>
                  <template v-else>
                    <span  class="primary cur">
                      {{ scope.row[scope.column.property] }}
                    </span>
                  </template>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->

          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="2000107">
                  <span class="primary cur" @click="showLog(scope.row.orderId)"
                    >日志</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import LogRightDialog from 'components/logRightDialog';
import ImportBtn from 'components/importBtn';
import CheckNameDialog from './checkNameDialog';
import DiffFeeDialog from './diffFeeDialog';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  customerOrderList,
  customerOrderCreateBill,
  customerOrderTotal,
  createOrderBillByExcel,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    LogRightDialog,
    ImportBtn,
    CheckNameDialog,
    DiffFeeDialog,
    TableSetting,
  },
  data () {
    return {
      totalData: {
        receiveToatlFee: 0,
        uncollectedTotalFee: 0,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'orderId',
        title: [ // 表头
          { prop: 'orderId', label: '订单号', fixed: true },
          { prop: 'dependDateStr', label: '发车时间' },
          { prop: 'billNumber', label: '账单号码' },
          { prop: 'customName', label: '客户名称' },
          { prop: 'checkName', label: '对账名称' },
          { prop: 'customNumber', label: '客户回单号' },
          { prop: 'plateNumber', label: '车牌号码' },
          { prop: 'carType', label: '车型' },
          { prop: 'sourceRegionName', label: '运输线路', w: '160px' },
          { prop: 'sourceName', label: '线路名称' },
          { prop: 'orderTypeName', label: '线路属性' },
          { prop: 'orgName', label: '归属部门' },
          { prop: 'goodsInfo', label: '货物信息' },
          { prop: 'carDependDate', label: '实际发车时间' },
          { prop: 'carStartDate', label: '实际离台时间' },
          { prop: 'carArriveDate', label: '实际到达时间' },
          { prop: 'costPriceDouble', label: '订单收入' },
          { prop: 'incomeExceptionFeeDouble', label: '异常款' },
          { prop: 'estimateIncomeFeeDouble', label: '订单收入合计' },
          { prop: 'diffFeeDouble', label: '对账调整' },
          { prop: 'affirmIncomeFeeDouble', label: '确认收入' },
          { prop: 'getAmountDouble', label: '核销金额' },
          { prop: 'realIncomeDouble', label: '实收' },
          { prop: 'financeStsName', label: '发票' },
          { prop: 'financeStsName', label: '核销状态' },
          { prop: 'orderStateName', label: '订单状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: customerOrderList,
    // 导入
    async onImportBtnSub (data) {
      data.myFile = data.file;
      delete data.bizCodes;
      delete data.file;
      createOrderBillByExcel(data);
    },
    async getOtherMsg (params) {
      const res = await customerOrderTotal(params);
      if (!res.failed) {
        this.totalData = res;
      }
    },
    showCheckNameDialog () { // 修改对账名称
      if (this.tableData.selectResult.length === 0) {
        this.$message.warning('请先选择操作对象');
        return;
      }
      for (let i = 0; i < this.tableData.selectResult.length; i++) {
        if (this.tableData.selectResult[i].billNumber) {
          this.$message.warning('选中数据中有已打包数据，不可修改');
          return;
        }
      }
      this.$refs.checkNameDialog.show(this.tableData.selectResult);
    },
    async customerOrderCreateBill () { // 创建订单
      if (this.tableData.selectResult.length === 0) {
        this.$message.warning('请先选择操作对象');
        return;
      }
      const orderIds = this.tableData.selectResult.map((item) => item.orderId);
      const res = await customerOrderCreateBill({
        orderIds: orderIds.join(','),
      });
      if (!res.failed) {
        this.$message.success('账单创建成功');
      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    toOrderDetail (item) {
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}`,
        full: true,
      });
    },
    // toBillDetail (item) {
    //   this.jump({
    //     label: '应收账单',
    //     url: `/manage/getPay/customer/bill?orderId=${item.orderId}`,
    //   });
    // },
    showDiffFeeDialog (item) { // 对账调整
      this.$refs.diffFeeDialog.show(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
